import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, AlertCircle } from 'lucide-react';
import './ErrorPages.css';

const NotFound = () => {
  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-animation">
          <div className="error-icon-wrapper">
            <AlertCircle size={80} className="error-icon" />
          </div>
        </div>

        <h1 className="error-code">404</h1>
        <h2 className="error-title">Page Not Found</h2>
        <p className="error-description">
          Sorry, the page you are looking for doesn't exist or has been moved.
        </p>

        <div className="error-actions">
          <Link to="/" className="error-button primary">
            <Home size={20} />
            <span>Go Home</span>
          </Link>
          <Link to="/products" className="error-button secondary">
            <Search size={20} />
            <span>Browse Products</span>
          </Link>
        </div>

        <div className="error-help">
          <p>Need help? <a href="#">Contact your support</a></p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
